import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import Breadcrumbs from "../../../layout/breadcrumb";
import { Alert, Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Row } from "reactstrap";
import DropZone from "../../../share-components/upload/dropzone";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addPartnerInvoiceData,
  getPartnerSettings,
  getPartnersInvoiceData,
  getStatementReconsiliationSettings,
  setReconciliationVal,
} from "../store/partnerSlice";
import UploadInvoices from "../content/UploadInvoices";
import BlinkingOverlayMessage from "../content/BlinkingOverlayMessage";
import PreLoader from "../../../share-components/ui/preLoader";
import { Accordion } from "react-bootstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import Select from "react-select";
import { toast } from "react-toastify";

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 50,
    border: state.isFocused ? "1px solid #999" : "1px solid #ccc",
    backgroundColor: "#f7f7f7",
    boxShadow: state.isFocused ? "0 0 0 1px #999" : "none",
    borderRadius: 6,
    "&:hover": {
      borderColor: "#999",
    },
  }),
};

const orderTypes = [
  { id: 1, name: "Sale" },
  { id: 2, name: "Return" },
];

function UploadInvoice() {
  const dispatch = useDispatch();
  const partnerState = useSelector(({ partner }) => partner.partner);
  const [file, setFile] = useState(null);
  const [mappingFile, setMappingFile] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isHavingColumns, setIsHavingColumns] = useState(false);
  const [updatedColumns, setUpdatedColumns] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [activeKey, setActiveKey] = useState("0");
  const [errors, setErrors] = useState([]);
  const [partner, setPartner] = useState(null);

  const dataMenu = [
    {
      type: 1,
      text: "Partner",
      link: "/partner",
    },
    {
      type: 0,
      text: "Upload Invoice",
    },
  ];

  useEffect(() => {
    dispatch(getStatementReconsiliationSettings()).then((res) => {
      dispatch(setReconciliationVal(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    if (partner) {
      setPageLoading(true);
      const id = partner?.id;
      dispatch(getPartnerSettings(id)).then((res) => {
        setPageLoading(false);

        setIsHavingColumns(res.payload.is_having_invoice_columns ?? false);
        setUpdatedColumns(res.payload.fields);
      });
    }
  }, [dispatch, partner]);

  useEffect(() => {
    setActiveKey(isHavingColumns ? null : "0");
  }, [isHavingColumns]);

  const handleFileUpload = (event) => {
    let file;

    if (Array.isArray(event)) {
      file = event[0];
    } else if (event?.target?.files) {
      file = event.target.files[0];
    }

    if (!file) return;

    setErrors([]);
    setFile(file);
  };
  
  function handleSubmit() {
    if (!partner || Object.keys(partner).length === 0) {
      toast.error("You must select a partner before mapping or uploading your Excel sheet.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", partner ? partner?.id : null);
    formData.append("isHavingColumns", isHavingColumns ? 1 : 0);

    setLoading(true);
    dispatch(addPartnerInvoiceData(formData)).then((res) => {
      setLoading(false);
      if (!res.error) {
        setFile(null);
        setErrors(res.payload.original?.errors ?? []);
      } else {
        console.error("File upload failed:", res);
      }
    });
  }

  const groupedErrors = useMemo(() => {
    if (!Array.isArray(errors)) return {};

    return errors.reduce((acc, err) => {
      const key = err.mp_order_number ?? err.item_id ?? "UNKNOWN_ORDER";

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(err);
      return acc;
    }, {});
  }, [errors]);

  const partnerChange = (e) => {
    setPartner(e ? e : null);
    setFile(null);
    setMappingFile(null);
  };

  return (
    <Fragment>
      <>
        <Breadcrumbs title="Invoice Upload" data={dataMenu} />
        <Container fluid={true} className="product-wrapper">
          <div className="product-grid">
            <div className="feature-products">
              <Card>
                <CardBody style={{ padding: 15 }}>
                  <Row style={{ padding: 10, marginBottom: 20 }} className="d-flex align-items-center">
                    <Col sm={8}>
                      <p style={{ fontSize: "13px", color: "#FF2828" }}>
                        <strong>Note:</strong> Before mapping or uploading your file, please select a partner first.
                      </p>
                    </Col>
                    <Col sm={4}>
                      <Select
                        placeholder={<div>Select the Partner</div>}
                        className="select2-filter"
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        isClearable
                        cacheOptions
                        styles={customStyles}
                        options={partnerState.reconciliationSettings.partners}
                        onChange={partnerChange}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </Col>
                  </Row>
                  <>
                    {pageLoading ? (
                      <div style={{marginTop: 150, minHeight: 100}}>
                        <PreLoader />
                      </div>
                    ) : (
                      <Accordion flush activeKey={activeKey} onSelect={(eventKey) => setActiveKey(eventKey)}>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>Mapping Headers</Accordion.Header>
                          <Accordion.Body>
                            <UploadInvoices
                              invoiceColumns={updatedColumns}
                              isHavingColumns={isHavingColumns}
                              setIsEditMode={setIsEditMode}
                              isEditMode={isEditMode}
                              setHasChanges={setHasChanges}
                              hasChanges={hasChanges}
                              setfields={setUpdatedColumns}
                              setIsHavingColumns={setIsHavingColumns}
                              partner={partner}
                              setMappingFile={setMappingFile}
                              mappingFile={mappingFile}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    )}
                  </>
                </CardBody>
              </Card>

              {(isHavingColumns && !pageLoading && partner) && (
                <>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col className="mb-3" md={12}>
                          <p className="sub-title font-weight-bold">Upload Invoice</p>
                        </Col>
                      </Row>

                      {isHavingColumns && !isEditMode && (
                        <Row>
                          <Col md={12}>
                            <Alert className="my-1" style={{ color: "#0f5132", backgroundColor: "#d1e7dd", borderColor: "#badbcc" }}>
                              <p style={{ fontSize: 14, fontWeight: 600 }} className="mb-1">
                                Your invoice column mapping has been successfully defined.
                              </p>
                              <p style={{ marginTop: 0 }}>
                                <strong>Note:</strong> You can now upload your monthly invoices using this same format. If you wish to change your
                                mapping later, please contact the administrator.
                              </p>
                            </Alert>
                          </Col>
                        </Row>
                      )}

                      <Row className="mb-3">
                        <Col sm={12}>
                          <DropZone
                            placeholder="Upload your excel file here"
                            extension=".csv,.xls,.xlsx"
                            onChangeFile={handleFileUpload}
                            customContainerStles={{ paddingRight: 0, paddingLeft: 0 }}
                            isInvoiceUpload
                          />
                        </Col>

                        {file && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "10px",
                              backgroundColor: "#f8f9fa",
                              padding: "10px 15px",
                              borderRadius: "6px",
                              border: "1px solid #ddd",
                              marginLeft: 17,
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span style={{ fontSize: "16px" }}>📄</span>
                              <span style={{ color: "#333", fontWeight: 500 }}>{file.name}</span>
                            </div>
                            <button
                              onClick={() => setFile(null)}
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                color: "#dc3545",
                                fontSize: "18px",
                              }}
                              title="Remove file"
                            >
                              &times;
                            </button>
                          </div>
                        )}

                        {errors && errors.length > 0 && (
                          <Col sm={12}>
                            <div
                              style={{
                                marginTop: "15px",
                                border: "1px solid #f5c2c7",
                                background: "#f8d7da",
                                padding: "15px",
                                borderRadius: "6px",
                                color: "#842029",
                              }}
                            >
                              <h5 style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <span style={{ fontSize: "20px", marginRight: "8px" }}>⚠️</span>
                                Import completed with some orders not found
                                <span style={{ marginLeft: "8px", fontSize: "14px", fontWeight: "600" }}>({errors.length} Not Found Records)</span>
                              </h5>

                              <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                                {Object.entries(groupedErrors).map(([mpOrder, errList]) => (
                                  <div
                                    key={mpOrder}
                                    style={{
                                      background: "#fff",
                                      border: "1px solid #f1b0b7",
                                      borderRadius: "5px",
                                      padding: "10px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <strong>MP Order: {mpOrder}</strong>

                                    <ul style={{ marginTop: "5px", marginBottom: 0 }}>
                                      {errList.map((e, index) => (
                                        <li key={index}>
                                          <strong>EAN:</strong> {e.ean_number} — <span style={{ fontSize: "13px" }}>{e.reason}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>

                      <div className="mt-2 d-flex justify-content-end">
                        <div className="p-2 d-flex" style={{ gap: 2 }}>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSubmit();
                            }}
                            disabled={loading || !file || !partner || Object.keys(partner).length === 0}
                            className="btn btn-primary btn-block mt-1"
                          >
                            {loading ? (
                              <>
                                {" "}
                                <i className="fa fa-spinner fa-spin fa-lg spinner" /> Submitting
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>

                      {loading && (
                        <BlinkingOverlayMessage
                          visible={loading}
                          title="Uploading your file..."
                          subtitle="Please don’t close or refresh this page until the upload completes."
                          position={{
                            bottom: "-9%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        />
                      )}
                    </CardBody>
                  </Card>
                </>
              )}
            </div>
          </div>
        </Container>
      </>
    </Fragment>
  );
}

export default UploadInvoice;
